import { Component } from "react";
import { connect } from "react-redux";
import LoadingBar from "react-redux-loading-bar";
import { ToastContainer } from "react-toastify";

import storage from "./apis/Storage";

import "./App.css";

import Header from "./layouts/Header/Header";
import Footer from "./layouts/Footer/Footer";
import SideNavbar from "./layouts/SideNavbar/SideNavbar";

import Routes from "./routes/Index";
import DistributorUserRoutes from "./routes/DistributorUserRoutes";
import DefaultRoutes from "./routes/DefaultRoutes";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showNavbar: true,
    };
  }

  toggleNavbar = () => {
    setTimeout(() => {
      this.setState((prev) => ({
        showNavbar: !prev.showNavbar,
      }));
    }, 150);
  };

  // Determine which routes to use
  getRouteComponent = () => {
    const { userRights, userRole } = this.state;
    // Only use Distributor routes if user has rights AND is not CoreAppUser
    if (userRights && userRole !== "CoreAppUser") {
      return DistributorUserRoutes;
    }
    return Routes;
  };

  renderLayout = (SidebarComponent, RouteComponent) => (
    <>
      <Header
        showNavbar={this.state.showNavbar}
        onNavToggle={this.toggleNavbar}
      />

      <SidebarComponent
        onClickOutside={this.toggleNavbar}
        isNavbarOpen={this.state.showNavbar}
      />

      <div className="content-wrapper">
        <section className="content">
          <main className="container-fluid">
            <RouteComponent />
            {this.props.children}
          </main>
        </section>
      </div>

      <Footer />
    </>
  );

  render() {
    const isLogin = storage.get("_appLogged") === "true";

    let userRights = null;

    try {
      userRights = JSON.parse(storage.get("_userRights") || "null");
    } catch {
      userRights = null;
    }

    const userRole = storage.get("_appUserRole");

    return (
      <>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          limit={3}
          hideProgressBar
          closeOnClick
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

        <LoadingBar
          updateTime={10}
          maxProgress={100}
          showFastActions={false}
          progressIncrease={10}
          style={{
            position: "fixed",
            top: 0,
            opacity: 1,
            backgroundColor: "#ea5f2d",
            height: "6px",
            zIndex: "999999",
          }}
        />

        {!isLogin ? (
          <DefaultRoutes />
        ) : (
          this.renderLayout(SideNavbar, this.getRouteComponent())
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  isSignedIn: state.auth.isSignedIn,
  token: state.auth.token,
  userId: state.auth.userId,
});

export default connect(mapStateToProps)(App);
